export const NON_REDIRECT_DOMAINS = [
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.co.in',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'protonmail.com',
  'zoho.com',
  'yandex.com',
  'gmx.com',
  'mail.com',
  'fastmail.com',
  'tutanota.com',
  'inbox.com',
  'rediffmail.com',
  'microsoft.com',
  'google.com',
  'office.com',
  'outlook.office365.com',
];
